import { LinkOutlined } from '@ant-design/icons';
import { SettingDrawer } from '@ant-design/pro-components';
import { history, Link } from '@umijs/max';
import { getRoleMenuList } from '@/services/system';
import React from 'react';
import {
  AvatarDropdown,
  AvatarName,
  Footer,
  Question,
  SelectLang,
} from '@/components';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';
import '@ant-design/v5-patch-for-react-19';

const isDev = process.env.NODE_ENV === 'development';
const loginPath = '/user/login';

/**
 * @see https://umijs.org/docs/api/runtime-config#getinitialstate
 * */
export async function getInitialState() {
  const fetchUserInfo = async () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return userInfo;
    } catch (_error) {
      history.push(loginPath);
    }
    return undefined;
  };
  // 如果不是登录页面，执行
  const { location } = history;
  if (
    ![loginPath, '/user/register', '/user/register-result'].includes(
      location.pathname,
    )
  ) {
    const currentUser = await fetchUserInfo();

    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings,
    };
  }
  return {
    fetchUserInfo,
    settings: defaultSettings,
  };
}

// ProLayout 支持的api https://procomponents.ant.design/components/layout
export const layout = ({
  initialState,
  setInitialState,
}) => {
  return {
    actionsRender: () => [
      // <Question key="doc" />,
      // <SelectLang key="SelectLang" />,
    ],
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    waterMarkProps: {
      content: initialState?.currentUser?.displayName,
    },
    // footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      // 如果没有登录，重定向到 login
      if (!initialState?.currentUser && location.pathname !== loginPath) {
        history.push(loginPath);
      }
    },
    bgLayoutImgList: [
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/D2LWSqNny4sAAAAAAAAAAAAAFl94AQBr',
        left: 85,
        bottom: 100,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/C2TWRpJpiC0AAAAAAAAAAAAAFl94AQBr',
        bottom: -68,
        right: -45,
        height: '303px',
      },
      {
        src: 'https://mdn.alipayobjects.com/yuyan_qk0oxh/afts/img/F6vSTbj8KpYAAAAAAAAAAAAAFl94AQBr',
        bottom: 0,
        left: 0,
        width: '331px',
      },
    ],
    menuHeaderRender: undefined,
    menu: {
      request: async (params, defaultMenuData) => {
        try {
          const res = await getRoleMenuList();
          if (res.code === 200) {
            const keys = res.data.map(item => item.url);
            for (let item of defaultMenuData) {
              if (item.path === '/setting' || item.path === '/main') {
                item.children = item.children.filter(child => keys.includes(child.path.replace('/detail/:id', '')));
                for (let child of item.children) {
                  if (child.children) {
                    child.children = child.children.filter(e => keys.includes(e.path.replace('/detail/:id', '')));
                  }
                }
                item.children = item.children.filter(child => !Array.isArray(child.children) || child.children.length > 0);
              }
            }
            return defaultMenuData.filter(item => !Array.isArray(item.children) || item.children.length > 0);
          } else {
            return defaultMenuData.filter(item => !['/setting', '/main'].includes(item.path));
          }
        } catch (error) {
          return defaultMenuData.filter(item => !['/setting', '/main'].includes(item.path));
        }
      }
    },
    // 自定义 403 页面
    // unAccessible: <div>unAccessible</div>,
    // 增加一个 loading 的状态
    childrenRender: (children) => {
      // if (initialState?.loading) return <PageLoading />;
      return (
        <>
          {children}
          {/* {isDev && (
            <SettingDrawer
              disableUrlParams
              enableDarkTheme
              settings={initialState?.settings}
              onSettingChange={(settings) => {
                setInitialState((preInitialState) => ({
                  ...preInitialState,
                  settings,
                }));
              }}
            />
          )} */}
        </>
      );
    },
    ...initialState?.settings,
  };
};
// let extraRoutes;
// export function patchRoutes({ routes, routeComponents }) {
//   console.log("routes===", routes, routeComponents, extraRoutes);
//   // 根据 extraRoutes 对 routes 做一些修改
//   if (Array.isArray(extraRoutes) && extraRoutes.length > 0) {
//     for (let index in routes) {
//       let item = routes[index];
//       if (item.path === '/') {
//         console.log("item===", item);
//         item.children.push({
//           path: '/main/patient',
//           name: '患者管理',
//           icon: 'user',
//           component: './patient',
//         });
//         // if (extraRoutes.includes(item.path.replace('/detail/:id', ''))) {
//         //   console.log("item===", item);
//         // }
//         break;
//       }
//     }
//   }
//   console.log("routes===", routes)
// }
// export function render(oldRender) {
//   getRoleMenuList()
//     .then((res) => {
//       if (res.code === 200) {
//         extraRoutes = res.data.map(e => e.url);
//       } else {
//         extraRoutes = null;
//       }
//       oldRender();
//     })
//     .catch(() => {
//       extraRoutes = null;
//       oldRender();
//     });
// }

/**
 * @name request 配置，可以配置错误处理
 * 它基于 axios 和 ahooks 的 useRequest 提供了一套统一的网络请求和错误处理方案。
 * @doc https://umijs.org/docs/max/request#配置
 */
export const request = {
  baseURL: '',
  ...errorConfig,
};
